import EasyGraphQLRequest from 'easyjs/lib/GraphQL/Request'
import { getXAPIEnv } from '@/plugins/account'
import store from '@/store'
export default {

  getHeaders (headers) {
    if (!headers['x-api-env']) {
      headers['x-api-env'] = getXAPIEnv()
    }
    return headers
  },

  query (service, data, headers = {}, vars = {}, showLoading = false) {
    if (showLoading) {
      store.commit('store/setLoading', true)
    }
    return EasyGraphQLRequest.query({
      service: service,
      data: data,
      headers: this.getHeaders(headers),
      vars: vars
    }).then(function (response) {
      if(showLoading) {
        store.commit('store/setLoading', false)
      }
      return response  
    }).catch(function(response) {
      if(showLoading) {
        store.commit('store/setLoading', false)
      }
    })
  },

  mutation (service, data, headers = {}, vars = {}, showLoading = false) {
    if (showLoading) {
      store.commit('store/setLoading', true)
    }
    return EasyGraphQLRequest.mutate({
      service: service,
      data: data,
      headers: this.getHeaders(headers),
      vars: vars
    }).then(function (response) {
      if(showLoading) {
        store.commit('store/setLoading', false)
      }
      return response
    })
  }
}
